var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, EButtonType } from 'src/ui/components/button/Button';
import styles from './usersParams.module.scss';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
export var UsersParams = function (props) {
    var i18n = props.i18n, onExport = props.onExport, onCreateUser = props.onCreateUser, onImportUsers = props.onImportUsers;
    return (_jsxs("aside", __assign({ className: styles.casesParamsWrapper }, { children: [_jsx(Button, { label: getPropsByKeyPath(i18n, 'components.userActions.addUser'), type: EButtonType.NEUTRAL, classname: styles.buttons, leftIcon: E_ICONS.ADD, onClick: onCreateUser }), _jsx(Button, { label: getPropsByKeyPath(i18n, 'components.userActions.exportUsers'), type: EButtonType.NEUTRAL, classname: styles.buttons, leftIcon: E_ICONS.EXPORT, onClick: onExport }), onImportUsers && _jsx(Button, { label: getPropsByKeyPath(i18n, 'components.userActions.importUsers'), type: EButtonType.NEUTRAL, classname: styles.buttons, leftIcon: E_ICONS.DOWNLOAD, onClick: onImportUsers })] })));
};
